import { useState, useCallback } from "react";
import { MonthlyReportService } from "../../../application/services/aiServices/monthlyReportService";

const monthlyReportService = new MonthlyReportService();

export const useMonthlyReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [monthlyReport, setMonthlyReport] = useState(null);

  const getMonthlyReportByMonthAndYear = useCallback(async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await monthlyReportService.getMonthlyReportByMonthAndYear(year, month);
      if (result.success) {
        setMonthlyReport(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const generateMonthlyReport = useCallback(async (year, month) => {
    setLoading(true);
    setError(null);
    try {
      const result = await monthlyReportService.generateMonthlyReport(year, month);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getMonthlyReportByMonthAndYear,
    generateMonthlyReport,
    monthlyReport,
    loading,
    error,
  };
};